import { StepperAction } from '@axo/insurance/feature/providers';

export const completeAction: StepperAction = {
  type: 'Set step data',
  scope: { parentType: 'verifyPaymentCard' },
  payload: { isCompleted: true },
};
